"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animates = animates;
exports.getWinScrollY = void 0;
exports.reinitIframe = reinitIframe;
exports.scaleAnimation = void 0;
exports.throttle = throttle;
exports.windowAddEventListener = windowAddEventListener;
exports.windowRemoveEventListener = windowRemoveEventListener;
// task perform  queue

const queuePerformTask = new WeakMap();
function init_compute(callback) {
  const contentWidth = window.innerWidth;
  if (contentWidth > 768) {
    callback(true, contentWidth);
  } else {
    callback(false, contentWidth);
  }
}
function windowAddEventListener(callback, delay) {
  if (!queuePerformTask.get(callback)) {
    queuePerformTask.set(callback, callback);
  }
  init_compute(callback);
  // console.log(queuePerformTask, 'queuePerformTask')
  window.addEventListener('resize', throttle(() => {
    init_compute(callback);
  }, delay || 1000));
}
function throttle(callback, delay) {
  let timeout = null;
  return function () {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      callback && callback();
    }, delay || 3000);
  };
}
function windowRemoveEventListener() {
  window.removeEventListener('resize', throttle);
}
function animates(ball, targetX, targetY) {
  const easing = 0.2;
  // if (ball.x > 295) {
  //     debugger;
  // }
  ball.x += (targetX - ball.x) * easing;
  ball.y += (targetY - ball.y) * easing;
  return {
    x: ball.x,
    y: ball.y,
    targetX
  };
}
const nowDate = new Date().getTime();
function reinitIframe(props) {
  // console.log(props, 'import');
  const _ref = props || {},
    filedVideoBg = _ref.filedVideoBg,
    filedVideoList = _ref.filedVideoList,
    postMessageUrl = _ref.postMessageUrl;
  const iframe = document.getElementById('frame_child_content');
  function requestAnimationRequestFunc() {
    if (new Date().getTime() - nowDate >= 2000) {
      iframe.contentWindow.postMessage({
        status: '1',
        filedVideoBg,
        filedVideoList
      }, postMessageUrl || 'https://www.tencentcloud.com/solution-new/tc-video'); // 父向子传递
      window.addEventListener('message', event => {
        // 父获取子传递的消息
        // console.log("%c收到children", "font-size:100px;");
        console.log(`收到children消息：${event.data}`);
        const iframe = document.getElementById('frame_child_content');
        if (event.data === '1') {
          // @ts-ignore
          iframe.style.display = 'none';
        }
      }, false);
    } else {
      requestAnimationRequestFunc();
    }
  }
  requestAnimationRequestFunc();
  try {
    // var bHeight = iframe.contentWindow.document.body.scrollHeight,
    // 	dHeight = iframe.contentWindow.document.documentElement.scrollHeight,
    // 	height = Math.max(bHeight, dHeight);
    // console.log(height)
    // @ts-ignore
    iframe.width = '100%';
    // @ts-ignore
    iframe.height = '100%';
    // @ts-ignore
    iframe.style.display = 'block';
  } catch (ex) {}
}
// intl tools
const getWinScrollY = () => window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

// //Conflict at the same level
// export function conflict(index?:any,event?:any) {
//   let pre_event: any;
//   return () => {
//     if (!event) return;
//     const val = event.target;
//     if (!pre_event) {
//       pre_event = val;
//     }
//     if (right_ref.current) {
//       pre_event.className = 'scene-tabs-description';
//       const _right_ref_ = right_ref.current.childNodes[index % listMapLen] as any;
//       _right_ref_.style.display = 'none';
//     }
//
//     if (useRefLi.current && right_ref.current) {
//       val.className = 'scene-tabs-description scene-tabs-h4--active';
//       const _right_ref_ = right_ref.current.childNodes[index % listMapLen] as any;
//       _right_ref_.style.className = 'scene-tabs-container-right__section ';
//       _right_ref_.style.display = 'block';
//     }
//     pre_event = val;
//   }()
// }
exports.getWinScrollY = getWinScrollY;
const scaleAnimation = str => {
  const schd = document.querySelector(`#${str}`);
  // const windowWidth = schd.parentNode ? schd.parentNode.clientWidth : 0;
  const windowWidth = window.innerWidth;
  const domeWidthValue = 768;
  let scale = 1;
  if (windowWidth < domeWidthValue) {
    scale = 375 / domeWidthValue;
  } else {
    scale = windowWidth / domeWidthValue > 1 ? 1 : windowWidth / domeWidthValue;
  }
  // @ts-ignore
  schd.style.transform = `scale(${scale}) translate(-50%, -50%)`;
};
exports.scaleAnimation = scaleAnimation;